import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

export interface TypeBlockRichTextFields {
    internalName: EntryFieldTypes.Symbol;
    richText?: EntryFieldTypes.RichText;
}

export type TypeBlockRichTextSkeleton = EntrySkeletonType<TypeBlockRichTextFields, 'blockRichText'>;
export type TypeBlockRichText<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockRichTextSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockRichText<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockRichText<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockRichText';
}
